import { setMeta, checkRule } from '@/router/middleware'
import routerView from '@/router/routerView'


const AffiliScriptMerchants = () => import ('@/views/developers/AffiliScriptMerchants')


export default {
    path: 'developers',
    redirect: 'developers/affili-script-merchants',
    component: routerView,
    children: [
        {
            path: 'affili-script-merchants',
            name: 'developers.affili-script-merchants',
            component: AffiliScriptMerchants,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'developer.affili_script',
                rules: {
                    user: ['view_script']
                },
            }
        },
    ]
}